export default __webpack_public_path__ + "static/media/profileSetupIcon.96773d03.svg";